import { render, staticRenderFns } from "./ModalVisualizarHistorico.vue?vue&type=template&id=7109c2f4&lang=pug"
import script from "./ModalVisualizarHistorico.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarHistorico.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarHistorico.vue?vue&type=style&index=0&id=7109c2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports